import React from 'react';
import { get } from 'lodash';

import Schema from '../../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import { getLocalstorageToken } from '../../../../../../../context/AuthHelper';
import SachkostenVN, { GetVNSachkostenFormStruc } from './SachkostenVN';
const P = Schema.attributes;

export const GetSachkostenVN = (application: any, kostenKategories: any) => {
	const OrgaStruc = [
		{
			label: 'Antragsteller',
			content: <SachkostenVN kostentraeger="Antragsteller" unternehmenId={get(getLocalstorageToken(), 'organisationId')} />,
			formStruc: GetVNSachkostenFormStruc(
				application,
				get(getLocalstorageToken(), 'organisationId'),
				'Antragsteller',
				kostenKategories,
			),
		},
	];
	const PartnerStruc = get(application, P.Zuwendungsantrag.schema.attributes.Partner.path, []).map((ele: any, i: number) => {
		return {
			label: `Partner ${i + 1}`,
			content: <SachkostenVN kostentraeger="Projektpartner" unternehmenId={get(ele, 'Unternehmen.id')} />,
			formStruc: GetVNSachkostenFormStruc(application, get(ele, 'Unternehmen.id'), 'Projektpartner', kostenKategories),
		};
	});
	return [...OrgaStruc, ...PartnerStruc];
};
